import { jsxs, jsx } from 'react/jsx-runtime';
import { Spacer } from '@zapier/design-system';
import { clsx } from 'clsx';

const header = "_header_heod5_1";
const toprow = "_toprow_heod5_10";
const styles = {
	header: header,
	toprow: toprow
};

const PageHeaderBase = ({ topRowContent, children, className }) => {
  return jsxs("div", { className: clsx(styles.header, className), "data-zds": true, children: [topRowContent ? jsx("div", { className: styles.toprow, "data-zds": true, children: topRowContent }) : jsx(Spacer, { height: "var(--zds-space-20)" }), children] });
};

export { PageHeaderBase };
//# sourceMappingURL=PageHeaderBase.es.js.map
